import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import StyleAuxiliary from '../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { getGroups } from '../../../../services/axiosAdobe/_api';
import { getLibraryDocumentsPaginated } from '../_api';
import { catchAxiosError } from '../../../../services/axios/_utility';
import { raiseErrorBanner } from '../../../../components/MessageDispatch/messageDispatch';

/**
 * Third-party agreement document selection
 * Query for documents
 * Set default document (if available)
 * Disable the dropdown if there is only one document available
 */
const DocumentSelector = ({
	className,
	formik: { setFieldValue, ...formik },
	id,
	required = true,
}) => {
	const DEFAULT_AGREEMENT = 'UPMC System Access Agreement';
	const DEFAULT_GROUP = 'IMS';
	const [documentOptions, setDocumentOptions] = useState([]);
	const [disabled, setDisabled] = useState(true);
	const [sValue, setValue] = useState('');
	const dispatch = useDispatch();

	/**
	 * Initialize the documents data
	 */
	useEffect(() => {
		const getDocs = async () => {
			getGroups()
				.then(response => {
					const group =
						response?.data?.payload?.groupInfoList &&
						response.data.payload.groupInfoList.findIndex(
							group => group.groupName === DEFAULT_GROUP
						) > -1
							? response.data.payload.groupInfoList.find(
									group => group.groupName === DEFAULT_GROUP
							  )
							: response.data.payload.groupInfoList.find(
									group => group.isDefaultGroup === true
							  );
					if (group && group.groupId) {
						getLibraryDocumentsPaginated()
							.then(response => {
								if (response) {
									const newDocs = [];
									response
										.filter(libDoc => {
											return (
												libDoc.groupId === group.groupId
											);
										})
										.forEach(libDoc => {
											newDocs.push({
												key: libDoc.id,
												label: libDoc.name,
												value: libDoc.id,
											});
										});
									setDocumentOptions(newDocs);

									// set default doc, if doc(s) exist
									if (newDocs.length > 0) {
										const defaultValue = newDocs.find(doc =>
											doc['label'].includes(
												DEFAULT_AGREEMENT
											)
										);
										if (defaultValue !== undefined) {
											setValue(defaultValue.value);
											if (setFieldValue) {
												setFieldValue(
													id,
													defaultValue.value
												);
											}
										}

										// allow doc selection when more than one exist
										if (newDocs.length > 1) {
											setDisabled(false);
										}
									}
								}
							})
							.catch(error => {
								raiseErrorBanner(
									catchAxiosError(error),
									dispatch
								);
							});
					}
				})
				.catch(error => {
					raiseErrorBanner(catchAxiosError(error), dispatch);
				});
		};
		getDocs();
	}, [dispatch, id, setFieldValue]);

	/**
	 * Render a dropdown list of agreements
	 */
	return (
		<StyleAuxiliary classes={className}>
			<FormControl
				disabled={disabled}
				error={formik.touched[id] && formik.errors[id]}
				required={required}
				variant='filled'
			>
				<InputLabel id={id + '__label'}>Agreement Document</InputLabel>
				<Select
					id={id}
					error={formik.touched[id] && formik.errors[id]}
					inputProps={{ readOnly: disabled }}
					fullWidth
					label='Agreement Document'
					labelId={id + '__label'}
					name={id}
					onBlur={formik.handleBlur}
					onChange={e => {
						formik.handleChange(e);
						setValue(e.target.value);
					}}
					value={sValue}
					variant='filled'
				>
					{documentOptions.map(doc => (
						<MenuItem
							sx={{
								color: doc.label ? 'inherit' : 'transparent',
							}}
							key={doc.key}
							value={doc.value}
						>
							{doc.label ? doc.label : '--'}
						</MenuItem>
					))}
				</Select>
				<FormHelperText>
					{formik.touched[id] && formik.errors[id]
						? formik.errors[id]
						: ' '}
				</FormHelperText>
			</FormControl>
		</StyleAuxiliary>
	);
};

export { DocumentSelector };
